export enum OperatorKinds {
  Plus = 1,
  Minus = 2,  // TODO:V1の仕様の確認
}
